type T =
  | 'isSMEMode'
  | 'correlation'
  | 'correlation_id'
  | 'user-role'
  | 'discipline'
  | 'course_id'
  | 'system'
  | 'person_ID'
  | 'login_session_id'
  | 'conversation_id'
  | 'show_history'
  | 'person_id_type';
type T2 = 'partner' | 'book_code' | 'exercise_id' | 'version';

function isOfTypeT2(keyInput: string): keyInput is T2 {
  return ['partner', 'book_code', 'exercise_id', 'version'].includes(keyInput);
}

function getQueryParam(queryParam: T | T2) {
  const params = new URLSearchParams(window.location.search);
  const subParams = new URL(window.location.href).pathname.substring(1).split('/');
  const parameters: Record<string, any> = {};

  subParams.map((param, index) => {
    if (index % 2 === 0) {
      if (subParams[index + 1]) parameters[param] = decodeURIComponent(subParams[index + 1]);
    }
  });

  const getParamValue = (value: string) => {
    // console.log(
    //   '_onFrameParameters',
    //   '_getParameterValue',
    //   parameters[value],
    //   params.get(queryParam)
    // );
    return parameters[value] ?? params.get(queryParam) ?? null;
  };

  // TODO: remove the subtype logs
  if (isOfTypeT2(queryParam)) {
    // console.log('_onFrameParameters', '_subParameter', parameters);
    const _param = queryParam;
    switch (_param) {
      case 'exercise_id':
        return getParamValue('exercises');
      case 'book_code':
        return getParamValue('books');
      case 'partner':
        return getParamValue('sources');
      case 'version':
        return getParamValue('exercise_version');
      default:
        return getParamValue(_param);
    }
  }

  return params.get(queryParam);
}

export default getQueryParam;
